import React, {Component} from 'react';
import { connect } from 'react-redux';

import * as billboardActions from '../actions/index';
import LoadingIndicator from '../../global/loading_indicator/loading_indicator';
import MediaUploadButton from '../media_upload_button/media_upload_button';
import logger from '../../global/logger';

// #482 — settings page for the org-scoped "series art" slide: an on/off
// toggle plus a manual upload that overrides whatever Planning Center
// sync last pulled from the org's current/upcoming plan. When enabled,
// BillboardPlaylist#active_items appends the effective image to every
// playlist's rotation on real devices.
export class BillboardSeriesArtView extends Component {

    componentDidMount() {
        this.props.onFetchSeriesArt();
    }

    toggleEnabled() {
        const series_art = this.props.series_art;
        const nextEnabled = !(series_art && series_art.series_art_enabled);
        this.props.onUpdateSeriesArt({ series_art_enabled: nextEnabled });
    }

    uploadArt(file) {
        logger.log("uploadSeriesArt: " + file);
        this.props.onUploadSeriesArt(file);
    }

    clearManualOverride() {
        this.props.onUpdateSeriesArt({ series_art_manual_url: '' });
    }

    render() {
        const { series_art, loading_series_art, updating_series_art, uploading_series_art } = this.props;

        if (loading_series_art && !series_art) {
            return <LoadingIndicator />;
        }

        const enabled = !!(series_art && series_art.series_art_enabled);
        const currentUrl = series_art && series_art.current_series_art_url;
        const hasManualOverride = !!(series_art && series_art.series_art_manual_url);
        const sourceLabel = hasManualOverride ? "Manually uploaded" : (currentUrl ? "From Planning Center" : null);

        return (
            <div>
                <p className="text-gray-500 text-xl mb-2">Series Art</p>
                <p className="text-sm text-gray-600 mb-4">
                    Show the current sermon series artwork as a slide in every playlist's rotation.
                    When Planning Center has series art on the current or upcoming plan, it's used
                    automatically — upload your own image below to override it.
                </p>

                <div className="bg-white text-gray-800 rounded shadow-md py-2 px-6 mb-4">
                    <div className="flex items-center justify-between py-3">
                        <div>
                            <div className="font-bold text-md">Show series art in rotation</div>
                            <div className="text-xs text-gray-400">Off by default. Applies to every playlist.</div>
                        </div>
                        <button
                            id="series_art_toggle"
                            type="button"
                            role="switch"
                            aria-checked={enabled}
                            disabled={updating_series_art}
                            onClick={() => this.toggleEnabled()}
                            className={"w-12 h-6 rounded-full relative cursor-pointer transition-colors " + (enabled ? "bg-green-500" : "bg-gray-300")}
                        >
                            <span className={"absolute top-0.5 h-5 w-5 bg-white rounded-full shadow-md transition-all " + (enabled ? "left-6" : "left-0.5")} />
                        </button>
                    </div>
                </div>

                <div className="bg-white text-gray-800 rounded shadow-md py-2 px-6 mb-4">
                    <div className="py-3">
                        <div className="font-bold text-md mb-2">Current image</div>
                        {currentUrl ? (
                            <div>
                                <div className="bg-gray-100 rounded-3xl overflow-hidden mb-2" style={{ aspectRatio: '16/9', maxWidth: '360px' }}>
                                    <img src={currentUrl} alt="Series art" className="w-full h-full object-contain" />
                                </div>
                                {sourceLabel && <p className="text-xs text-gray-400 mb-2">{sourceLabel}</p>}
                                {hasManualOverride && (
                                    <button
                                        type="button"
                                        onClick={() => this.clearManualOverride()}
                                        className="text-sm text-blue-500 hover:text-blue-700 px-3 py-1 border border-blue-300 rounded mb-2"
                                    >
                                        Use Planning Center art instead
                                    </button>
                                )}
                            </div>
                        ) : (
                            <div className="bg-gray-100 rounded-3xl p-6 text-center mb-2" style={{ maxWidth: '360px' }}>
                                <p className="text-gray-500 mb-2">No series art set yet</p>
                                <p className="text-gray-400 text-sm">Upload an image, or wait for the next Planning Center sync.</p>
                            </div>
                        )}

                        <MediaUploadButton
                            id="series_art_upload_button"
                            className=""
                            text={uploading_series_art ? "Uploading…" : "Upload Series Art"}
                            onUploadMedia={(file) => this.uploadArt(file)}
                        />
                        <div className="clear-both" />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        series_art: state.billboard.series_art,
        loading_series_art: state.billboard.loading_series_art,
        updating_series_art: state.billboard.updating_series_art,
        uploading_series_art: state.billboard.uploading_series_art,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onFetchSeriesArt: () => dispatch(billboardActions.fetchSeriesArt()),
        onUpdateSeriesArt: (attrs) => dispatch(billboardActions.updateSeriesArt(attrs)),
        onUploadSeriesArt: (file) => dispatch(billboardActions.uploadSeriesArt(file)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BillboardSeriesArtView);
